import {
        BarChart,
        Bar,
        ResponsiveContainer,
        XAxis,
        YAxis,
        Tooltip,
        Cell,
} from "recharts";

const CAT_COLORS = {
        politica: "#d4a017",
        media: "#79a3b1",
        justica: "#e63946",
        economico: "#6ea58b",
        social: "#b07c4a",
        historico: "#8c8473",
        ciencia_saude: "#7a9cc6",
        religiao: "#9b7fb8",
        esoterismo: "#6b5b95",
};

export const Dashboard = ({ stats }) => {
        if (!stats) return null;
        const cats = stats.by_category || [];
        const tops = stats.top_tags || [];
        const outlets = stats.by_outlet || [];
        const parties = stats.by_party || [];

        return (
                <section className="border-t border-[var(--line-strong)] bg-[var(--bg-deep)]">
                        <div className="mx-auto max-w-[1400px] px-6 lg:px-12 py-14">
                                <div className="flex items-end justify-between mb-10">
                                        <div>
                                                <div className="overline text-[var(--ink-faint)] mb-2">
                                                        § Análise · dossier panel
                                                </div>
                                                <h2 className="font-serif text-4xl md:text-5xl tracking-tight leading-none text-[var(--ink)]">
                                                        Cartografia da controvérsia.
                                                </h2>
                                        </div>
                                        <div className="hidden md:flex gap-12">
                                                <Metric
                                                        label="Tópicos"
                                                        value={stats.topics_total}
                                                        accent="var(--ink)"
                                                />
                                                <Metric
                                                        label="Artigos indexados"
                                                        value={stats.articles_total}
                                                        accent="var(--ai)"
                                                />
                                                <Metric
                                                        label="Índice médio"
                                                        value={`${stats.avg_controversy}/100`}
                                                        accent="var(--controversy)"
                                                />
                                        </div>
                                </div>

                                <div className="grid grid-cols-1 lg:grid-cols-12 gap-0 border border-[var(--line-strong)] bg-[var(--paper)]">
                                        {/* Categories chart */}
                                        <div className="lg:col-span-7 p-6 border-b lg:border-b-0 lg:border-r border-[var(--line-strong)]">
                                                <div className="overline text-[var(--ink-faint)] mb-4">
                                                        Tópicos por categoria
                                                </div>
                                                <div style={{ width: "100%", height: 220 }}>
                                                        <ResponsiveContainer width="99%" height={220} aspect={undefined}>
                                                                <BarChart
                                                                        data={cats}
                                                                        margin={{ top: 10, right: 10, left: -20, bottom: 0 }}
                                                                >
                                                                        <XAxis
                                                                                dataKey="label"
                                                                                axisLine={{ stroke: "var(--line-strong)" }}
                                                                                tickLine={false}
                                                                        />
                                                                        <YAxis
                                                                                axisLine={false}
                                                                                tickLine={false}
                                                                                allowDecimals={false}
                                                                        />
                                                                        <Tooltip
                                                                                cursor={{ fill: "rgba(212,160,23,0.06)" }}
                                                                                contentStyle={{
                                                                                        background: "var(--bg-deep)",
                                                                                        border: "1px solid var(--line-strong)",
                                                                                        color: "var(--ink)",
                                                                                        fontFamily: "JetBrains Mono",
                                                                                        fontSize: 11,
                                                                                }}
                                                                        />
                                                                        <Bar dataKey="n">
                                                                                {cats.map((c) => (
                                                                                        <Cell
                                                                                                key={c.category}
                                                                                                fill={CAT_COLORS[c.category] || "var(--ink-soft)"}
                                                                                        />
                                                                                ))}
                                                                        </Bar>
                                                                </BarChart>
                                                        </ResponsiveContainer>
                                                </div>
                                        </div>

                                        {/* Top tags */}
                                        <div className="lg:col-span-5 p-6">
                                                <div className="overline text-[var(--ink-faint)] mb-4">
                                                        Etiquetas frequentes
                                                </div>
                                                <ul className="space-y-2">
                                                        {tops.slice(0, 8).map((t, i) => (
                                                                <li
                                                                        key={t.tag}
                                                                        className="flex items-center gap-3"
                                                                >
                                                                        <span className="line-no w-8">
                                                                                .{String(i + 1).padStart(2, "0")}
                                                                        </span>
                                                                        <span className="text-sm flex-1 truncate text-[var(--ink)]">
                                                                                {t.tag}
                                                                        </span>
                                                                        <div className="flex-1 max-w-[100px] h-[2px] bg-[var(--line)]">
                                                                                <div
                                                                                        className="h-full bg-[var(--controversy)]"
                                                                                        style={{
                                                                                                width: `${Math.min(
                                                                                                        100,
                                                                                                        (t.n / (tops[0]?.n || 1)) * 100
                                                                                                )}%`,
                                                                                        }}
                                                                                />
                                                                        </div>
                                                                        <span className="font-mono text-xs text-[var(--ink-soft)] w-8 text-right">
                                                                                {t.n}
                                                                        </span>
                                                                </li>
                                                        ))}
                                                        {tops.length === 0 && (
                                                                <li className="text-sm text-[var(--ink-faint)] italic">
                                                                        Sem etiquetas indexadas.
                                                                </li>
                                                        )}
                                                </ul>
                                        </div>

                                        {/* Parties bar */}
                                        {parties.length > 0 && (
                                                <div className="lg:col-span-7 p-6 border-t border-[var(--line-strong)]">
                                                        <div className="overline text-[var(--ink-faint)] mb-4">
                                                                Menções a partidos · 7 dias
                                                        </div>
                                                        <ul className="grid grid-cols-2 md:grid-cols-3 gap-3">
                                                                {parties.slice(0, 9).map((p) => (
                                                                        <li
                                                                                key={p.party}
                                                                                className="flex items-center justify-between border border-[var(--line)] px-3 py-2 bg-[var(--bg-deep)]"
                                                                        >
                                                                                <span className="font-mono text-xs text-[var(--ink)]">
                                                                                        {p.party}
                                                                                </span>
                                                                                <span
                                                                                        className="font-mono text-sm font-bold"
                                                                                        style={{ color: "var(--controversy)" }}
                                                                                >
                                                                                        {p.n}
                                                                                </span>
                                                                        </li>
                                                                ))}
                                                        </ul>
                                                </div>
                                        )}

                                        {/* Outlets bar */}
                                        {outlets.length > 0 && (
                                                <div className="lg:col-span-5 p-6 border-t border-[var(--line-strong)] lg:border-l">
                                                        <div className="overline text-[var(--ink-faint)] mb-4">
                                                                Fontes activas
                                                        </div>
                                                        <ul className="space-y-2">
                                                                {outlets.slice(0, 8).map((o) => (
                                                                        <li
                                                                                key={o.outlet}
                                                                                className="flex items-center justify-between"
                                                                        >
                                                                                <span className="text-sm text-[var(--ink)]">
                                                                                        {o.outlet}
                                                                                </span>
                                                                                <span className="font-mono text-xs text-[var(--ai)]">
                                                                                        {o.n} artigos
                                                                                </span>
                                                                        </li>
                                                                ))}
                                                        </ul>
                                                </div>
                                        )}
                                </div>
                        </div>
                </section>
        );
};

const Metric = ({ label, value, accent }) => (
        <div>
                <div className="overline text-[var(--ink-faint)] mb-1">{label}</div>
                <div
                        className="font-serif text-4xl font-bold leading-none"
                        style={{ color: accent }}
                >
                        {value}
                </div>
        </div>
);

export default Dashboard;
